/*@ngInject*/
const DataSetRepository = function (baseRepository, formRegistrationModel, databaseDownloadSectionName, cachedDataSetsRepository, temporaryLoginTokenRepository) {

    angular.extend(this, baseRepository);

    this.createDataSet = function (dataSet) {
        let url = '/rest/DataSet';
        return this.post(url, dataSet);
    };

    this.updateDataSet = function (dataSet, name) {
        let url = '/rest/DataSet/update?dataSetName=' + encodeURIComponent(name);
        return this.post(url, dataSet).then(function (response) {
            cachedDataSetsRepository.removeFromCache(name);

            return response;
        });
    };

    this.deleteDataSet = function (name) {
        let url = '/rest/DataSet/' + name;
        return this.delete(url, name);
    };

    this.getDataSet = function (name) {
        let url = '/rest/DataSet',
            config = {
                params: {
                    dataSetName: name
                }
            };

        return this.get(url, config);
    };

    this.getGeneratorDefinitions = function (type) {
        let url = '/rest/DataSet/generatorDefinitions',
            config = {
                params: {
                    type: type
                }
            };
        return this.get(url, config);
    };

    this.getDataSetsByFilterUri = function (filterUri, requestParams) {
        let url = '/rest/DataSet/filter',
            config = {
                params: {
                    filterUri: filterUri,
                    sortBy: requestParams.key,
                    sortDirection: requestParams.sortType,
                    startIndex: requestParams.startIndex,
                    numberOfRows: requestParams.pageSize
                }
            };

        return this.get(url, config);
    };

    this.getDynamicDataSet = function (params, registrationId, isNotFormRelated) {
        let url = '/rest/DataSet/dynamicDataSet',
            config = {
                params: params
            };

        if (registrationId) {
            if (_.isNil(isNotFormRelated) || !isNotFormRelated) {
                url += '?registrationIdentifier=/DataSet/formRegistrationId/' + registrationId;
                formRegistrationModel.addRegistration(registrationId, '/rest/DataSet' + '?registrationIdentifier=/DataSet/formRegistrationId/' + registrationId);
            } else {
                url += '?registrationIdentifier=/DataSet/registrationId/' + registrationId;
            }
        }

        return this.get(url, config).then(function (response) {
            let dataItems = response.items;
            if (!_.isNil(response) && !_.isNil(response.items)) {
                if (!_.isNil(response.defaultValue)) {
                    dataItems = response.items;
                    _.each(dataItems, function (dataItem) {
                        if (dataItem.value === response.defaultValue.value) {
                            dataItem.isDefault = true;
                        }
                    });
                }
                response.items = dataItems;
            }
            return response;
        });
    };

    this.getDynamicDataSetItems = function (params, registrationId, isNotFormRelated) {
        return this.getDynamicDataSet(params, registrationId, isNotFormRelated).then(function(dataSet) {
            return dataSet.items;
        });
    };

    this.unregisterDynamicDataset = function (params, registrationId) {
        let url = '/rest/DataSet',
            config = {
                params: params
            };

        url += '?registrationIdentifier=/DataSet/registrationId/' + registrationId;

        return this.delete(url, config);
    };

    this.getDataSetNameToTypeMap = function () {
        let url = '/rest/DataSet/dataSetNamesToTypes';
        return this.get(url);
    };

    this.exportDataSetsByName = function (dataSetNames) {
        var url = '/database/DatabaseDownloadServlet',
            config = {
                params: {
                    sectionName: databaseDownloadSectionName.DATA_SETS,
                    entityIdentifiers: _.join(dataSetNames, ',')
                }
            };

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.get(url, config);
        });
    };

    this.exportDataSetsByNameWithFilter = function (filterUri, excludedDataSetNames) {
        var url = '/databaseWithFilter/DatabaseDownloadWithServlet',
            config = {
                params: {
                    sectionName: databaseDownloadSectionName.DATA_SETS,
                    filterUri: filterUri,
                    excludedEntityIdentifiers: excludedDataSetNames
                }
            };

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.get(url, config);
        });
    };

};

angular.module('umCore')
    .service('dataSetRepository', DataSetRepository);
